import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MiniplayerService {

  constructor() { }

  private IsVisible = new BehaviorSubject<boolean>(false);
  isVisible = this.IsVisible.asObservable();

  setVisibility(showMiniPlayer: boolean) {
    this.IsVisible.next(showMiniPlayer);
  }
}
